<template>
  <img src="~/assets/icon/icon-mastercard.svg" />
</template>
